import { isProduction } from '_lib/env'

export const SOURCE_VALUES = {
  DATASPHERE: 'datasphere',
  APA_PROD: 'apa-prod',
  APA_DEV: 'apa-dev',
}

export const SOURCES_ENV = {
  [SOURCE_VALUES.APA_DEV]: 'dev',
  [SOURCE_VALUES.APA_PROD]: 'prod',
}

const ALL_SOURCE_OPTIONS = [
  { label: 'Datasphere', value: SOURCE_VALUES.DATASPHERE },
  { label: 'Predactiv Platform (prod)', value: SOURCE_VALUES.APA_PROD },
  { label: 'Predactiv Platform (dev)', value: SOURCE_VALUES.APA_DEV },
]

// The Predactiv production data source must only be reachable from a
// production build; strip it from the source options in any other build so it
// can neither be selected nor used to connect to production.
export const SOURCE_OPTIONS = isProduction()
  ? ALL_SOURCE_OPTIONS.filter((option) => option.value !== SOURCE_VALUES.APA_DEV)
  : ALL_SOURCE_OPTIONS.filter((option) => option.value !== SOURCE_VALUES.APA_PROD)

export const COLLECTION_CONFIG = {
  [SOURCE_VALUES.DATASPHERE]: [
    {
      label: 'Custom Audiences',
      value: 'custom_audiences',
    },
    {
      label: 'Event Feeds',
      value: 'event_feeds',
    },
  ],
  [SOURCE_VALUES.APA_DEV]: [
    { label: 'Conversations', value: 'conversations' },
    { label: 'Dataset', value: 'datasets' },
    { label: 'Deliveries', value: 'deliveries' },
    { label: 'Contextual Similarity Models', value: 'contextual_similarity_models' },
    { label: 'Audiences Created Using Predictors', value: 'audiences_with_predictors' },
    { label: 'Insights Viewed', value: 'insights_viewed' },
  ],
  [SOURCE_VALUES.APA_PROD]: [
    { label: 'Conversations', value: 'conversations' },
    { label: 'Dataset', value: 'datasets' },
    { label: 'Deliveries', value: 'deliveries' },
    { label: 'Contextual Similarity Models', value: 'contextual_similarity_models' },
    { label: 'Audiences Created Using Predictors', value: 'audiences_with_predictors' },
    { label: 'Insights Viewed', value: 'insights_viewed' },
  ],
}

// Internal users are ShareThis / Predactiv staff. This mirrors the server-side
// definition behind the analytics `exclude_internal` filter
// (apa-api src/functions/analytics/internalFilter.js), so the user dropdown and
// the report it drives agree on who counts as internal.
export const INTERNAL_EMAIL_PATTERN = /@(sharethis|predactiv)\.com$/i

export const isInternalEmail = (email) => INTERNAL_EMAIL_PATTERN.test(email || '')

// react-select menu props shared by the analytics dropdowns. The page lays its
// filters out in narrow columns inside scrolling panels, which used to clip the
// menu; rendering it in a body-level portal lifts it out of those panels,
// `auto` placement flips it above the control when the viewport runs out of
// room below, and the capped list height keeps a long user list navigable on a
// short screen. The height has to come through `styles` because the uikit
// Select hardcodes `maxMenuHeight` after spreading incoming props.
export const DROPDOWN_MENU_PROPS = {
  menuPortalTarget: typeof document === 'undefined' ? null : document.body,
  menuPosition: 'fixed',
  menuPlacement: 'auto',
  styles: {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menuList: (base) => ({ ...base, maxHeight: 'min(50vh, 320px)' }),
  },
}
